var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33332 8V13.2533C9.35999 13.4533 9.29332 13.6667 9.13999 13.8067C8.87999 14.0667 8.45999 14.0667 8.19999 13.8067L6.85999 12.4667C6.70665 12.3133 6.63999 12.1067 6.66665 11.9133V8H6.64665L2.80665 3.08C2.57999 2.79333 2.63332 2.37333 2.91999 2.14667C3.04665 2.05333 3.18665 2 3.33332 2H12.6667C12.8133 2 12.9533 2.05333 13.08 2.14667C13.3667 2.37333 13.42 2.79333 13.1933 3.08L9.35332 8H9.33332Z",
    fill: "#2D4B9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFilled);
export default __webpack_public_path__ + "static/media/filter_filled.d4c2d7ab3504c0e71e2a12582da2c809.svg";
export { ForwardRef as ReactComponent };